/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const BasicSetup = defineMessages({
  title: {
    id: 'twilioMessaging.BasicSetup.title',
    defaultMessage: 'Basic setup'
  },
  subtitle: {
    id: 'twilioMessaging.BasicSetup.subtitle',
    defaultMessage:
      'SMS integration requires Twilio, see setup details below. <link>Learn more</link>'
  },
  twilioAccountInformation: {
    id: 'twilioMessaging.BasicSetup.twilioAccountInformation',
    defaultMessage: 'Twilio account information'
  },
  providerLabel: {
    id: 'twilioMessaging.BasicSetup.providerLabel',
    defaultMessage: 'Select text provider'
  },
  userLabel: {
    id: 'twilioMessaging.BasicSetup.userLabel',
    defaultMessage: 'Account SID'
  },
  userPlaceholder: {
    id: 'twilioMessaging.BasicSetup.userPlaceholder',
    defaultMessage: 'Enter Twilio account SID'
  },
  passwordLabel: {
    id: 'twilioMessaging.BasicSetup.passwordLabel',
    defaultMessage: 'Auth token'
  },
  passwordPlaceholder: {
    id: 'twilioMessaging.BasicSetup.passwordPlaceholder',
    defaultMessage: 'Enter Twilio auth token'
  },
  hidePassword: {
    id: 'twilioMessaging.BasicSetup.hidePassword',
    defaultMessage: 'Hide password'
  },
  showPassword: {
    id: 'twilioMessaging.BasicSetup.showPassword',
    defaultMessage: 'Show password'
  },
  phonePlaceholder: {
    id: 'twilioMessaging.BasicSetup.phonePlaceholder',
    defaultMessage: '+1 (234) 567-8901'
  },
  phoneNumberError: {
    id: 'twilioMessaging.BasicSetup.phoneNumberError',
    defaultMessage:
      'Phone numbers can only contain number characters (0-9) and plus(+), minus(-) and parenthesis.'
  },
  phoneNumberEmptyError: {
    id: 'twilioMessaging.BasicSetup.phoneNumberEmptyError',
    defaultMessage: 'Phone number cannot be empty.'
  },
  phoneNumberRequired: {
    id: 'twilioMessaging.BasicSetup.phoneNumberRequired',
    defaultMessage: 'Phone number is required.'
  },
  setup: {
    id: 'twilioMessaging.BasicSetup.setup',
    defaultMessage: 'Setup instructions'
  },
  instructionsDescription: {
    id: 'twilioMessaging.BasicSetup.instructionsDescription',
    defaultMessage: "For this integration to work, here's what you need to do:"
  },
  instructionsItemOne: {
    id: 'twilioMessaging.BasicSetup.instructionsItemOne',
    defaultMessage:
      'Get a Twilio phone number with SMS capabilities (MMS optional). Add the phone number your Twilio account uses for SMS integration below:'
  },
  instructionsItemTwo: {
    id: 'twilioMessaging.BasicSetup.instructionsItemTwo',
    defaultMessage:
      "In Twilio, set your phone number's messaging to configure with webhooks, which should be its default."
  },
  instructionsItemThree: {
    id: 'twilioMessaging.BasicSetup.instructionsItemThree',
    defaultMessage:
      "Copy and paste this webhook identifier as the address for incoming messages. Make sure it's set to HTTP POST."
  },
  webhookUri: {
    id: 'twilioMessaging.BasicSetup.webhookUri',
    defaultMessage: 'Webhook URI (uniform resource identifier)'
  },
  retrieveWebhookUri: {
    id: 'twilioMessaging.BasicSetup.generateWebhookUri',
    defaultMessage: 'Retrieve webhook URI'
  }
});
